import { CellType } from '@grapecity/wijmo.grid';
import { CollectionView } from '@grapecity/wijmo';
import * as React from 'react';
import * as wijmo from '@grapecity/wijmo';

import * as wjChart from '@grapecity/wijmo.react.chart';
import * as wjGrid from '@grapecity/wijmo.grid';
import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';

import { Col, Row, Container } from 'react-bootstrap';
import { useEffect, useState, useRef } from 'react';

import { toInt, toFloat, calcRate } from 'utils/numberUtils';
import { isBeforeThisMonth } from 'utils/dateUtils';
import './Analysis.css';

// 分析（契約単価）
function AnalysisKingakuTanka(props) {
  // 契約情報リスト
  const [keiyakuList, setKeiyakuList] = useState(new CollectionView([]));
  // 選択中の期
  const selectedPeriod = props.selectedPeriod;
  // グリッドのキー
  const [gridKey, setGridKey] = useState(0);

  useEffect(() => {
    setKeiyakuList(
      new CollectionView(
        props.keiyakuList.items.map((x) => ({
          ...x,
          UNIT_RATE: calcRate(x.CURRENT_UNIT_PRICE, x.BEFORE_UNIT_PRICE, 4),
        }))
      )
    );
  }, [props.keiyakuList]);

  //  グリッドの初期化
  function onInitialized(grid) {
    // ヘッダーを2段にする
    var extraRow = new wjGrid.Row();
    extraRow.cssClassAll = 'header-center';
    extraRow.allowMerging = true;
    var panel = grid.columnHeaders;
    panel.rows.splice(0, 0, extraRow);
    panel.setCellData(0, 0, '月');
    for (var i = 1; i < grid.columns.length; i++) {
      panel.setCellData(0, i, '契約金額・契約単価');
    }

    grid.formatItem.addHandler((sender, e) => {
      // フッターセルのスタイル設定
      if (e.panel === sender.columnFooters) {
        const colIndex = e.col;
        const rowIndex = e.row;

        // フッターの1行目の線を太くする
        if (rowIndex === 0) {
          e.cell.style.borderTop = 'double';
        }

        if (rowIndex == 0 && [1].includes(colIndex)) {
          // 前期
          e.cell.style.backgroundColor = '#fce4d6';
        } else if (rowIndex == 0 && [3].includes(colIndex)) {
          // 今期
          e.cell.style.backgroundColor = '#ddebf7';
        } else if (rowIndex == 0 && [2, 5, 6].includes(colIndex)) {
          // 黄色いセル
          e.cell.style.backgroundColor = '#ffff99';
        } else {
          // 他のセルの背景色をデフォルトに戻す
          e.cell.style.backgroundColor = '';
        }
      }
    });

    // フッターに２段追加
    grid.columnFooters.rows.push(new wjGrid.Row());
    grid.columnFooters.rows.push(new wjGrid.Row());

    // データ変更時に合計更新
    grid.collectionView.collectionChanged.addHandler(updateFooter);
    updateFooter(grid);
  }

  // 合計値を計算してフッターに設定
  function updateFooter(grid) {
    let data = grid?.itemsSource?.items;
    if (!data || data.length === 0) return;

    let panel = grid.columnFooters;

    // 月
    panel.setCellData(0, 0, '合計');
    panel.setCellData(1, 0, '前月まで');

    // 前期
    const beforeTotal = data.reduce((sum, item) => sum + (item['KIN_BEFORE_TOTAL'] || 0), 0);
    panel.setCellData(0, 1, beforeTotal);

    // 前月までの前期の合計
    const totalBeforeThisMonth = data
      .filter((item) => isBeforeThisMonth(item['MONTH'], selectedPeriod))
      .reduce((sum, item) => sum + (item['KIN_BEFORE_TOTAL'] || 0), 0);
    panel.setCellData(1, 1, totalBeforeThisMonth);

    // 前期の契約単価
    const beforeCount = data.reduce((sum, item) => sum + (item[`KEI_BEFORE_TOTAL`] || 0), 0);
    const beforeUnitPrice = beforeTotal / beforeCount;
    panel.setCellData(0, 2, beforeUnitPrice);

    // 今期の合計
    const currentTotal = data.reduce((sum, item) => sum + (item['KIN_CURRENT_TOTAL'] || 0), 0);
    panel.setCellData(0, 3, currentTotal);

    // 前月までの前期の合計と今期の合計の伸び率
    const upRate = calcRate(currentTotal, totalBeforeThisMonth, 4);
    panel.setCellData(1, 2, wijmo.format('{val:p1}', { val: upRate }));

    // 金額星表
    const kin_star_off_count = data.reduce(
      (cnt, item) => cnt + (item['KIN_STAR_TOTAL'] == '★' ? 1 : 0),
      0
    );
    const kin_star_on_count = data.reduce(
      (cnt, item) => cnt + (item['KIN_STAR_TOTAL'] == '☆' ? 1 : 0),
      0
    );
    panel.setCellData(0, 4, `${kin_star_on_count}☆${kin_star_off_count}★`);

    // 今期の契約単価
    const currentCount = data.reduce((sum, item) => sum + (item[`KEI_CURRENT_TOTAL`] || 0), 0);
    const currentUnitPrice = currentTotal / currentCount;
    panel.setCellData(0, 5, currentUnitPrice);

    // 昨対単価変動率
    let unitRate = calcRate(currentUnitPrice, beforeUnitPrice, 4);
    panel.setCellData(0, 6, wijmo.format('{val:p1}', { val: unitRate }));

    // 単価星表
    const unit_star_off_count = data.reduce(
      (cnt, item) => cnt + (item['STAR_UNIT_PRICE'] == '★' ? 1 : 0),
      0
    );
    const unit_star_on_count = data.reduce(
      (cnt, item) => cnt + (item['STAR_UNIT_PRICE'] == '☆' ? 1 : 0),
      0
    );
    panel.setCellData(0, 7, `${unit_star_on_count}☆${unit_star_off_count}★`);
  }

  return (
    <Container fluid className="p-0">
      <Row className="mt-2">
        <Col className="pl-3" md="7">
          <FlexGrid
            key={gridKey}
            isReadOnly={true}
            allowMerging="ColumnHeaders"
            allowSorting={false}
            allowDragging={false}
            itemsSource={keiyakuList}
            headersVisibility={'Column'}
            alternatingRowStep={0}
            initialized={onInitialized}
          >
            <FlexGridColumn
              binding="MONTH"
              header="月"
              allowMerging={true}
              width={60}
              align="center"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KIN_BEFORE_TOTAL"
              cssClass="before_cell"
              header={`${selectedPeriod - 1}期`}
              format="n0"
              width={100}
              align="right"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="BEFORE_UNIT_PRICE"
              header={`契約単価`}
              format="n0"
              width={100}
              align="right"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KIN_CURRENT_TOTAL"
              cssClass="current_cell"
              header={`${selectedPeriod}期`}
              format="n0"
              width={100}
              align="right"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="KIN_STAR_TOTAL"
              header="金額星表"
              width={100}
              align="center"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="CURRENT_UNIT_PRICE"
              header={`契約単価`}
              format="n0"
              width={100}
              align="right"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="UNIT_RATE"
              header={`昨対単価変動`}
              format="p1"
              width={100}
              align="right"
            ></FlexGridColumn>
            <FlexGridColumn
              binding="STAR_UNIT_PRICE"
              header="単価星表"
              width={100}
              align="center"
            ></FlexGridColumn>
          </FlexGrid>
        </Col>
        <Col className="pl-3" md="5">
          <wjChart.FlexChart
            header="移動年計　契約金額"
            itemsSource={keiyakuList.sourceCollection}
            bindingX="MONTH"
            chartType="Line"
            style={{ backgroundColor: '#f7f7f8', borderRadius: '8px' }}
          >
            {/* Y軸の最大・最小値を設定 */}
            <wjChart.FlexChartAxis wjProperty="axisY" min={0} />
            {/* X軸にY方向のグリッド線を表示 */}
            <wjChart.FlexChartAxis wjProperty="axisX" majorGrid={true} />
            {/* 凡例の位置を下に配置 */}
            <wjChart.FlexChartLegend position="Bottom" />
            <wjChart.FlexChartSeries name={`${selectedPeriod - 1}期`} binding="KIN_BEFORE_TOTAL" />
            <wjChart.FlexChartSeries name={`${selectedPeriod}期`} binding="KIN_CURRENT_TOTAL" />
          </wjChart.FlexChart>
        </Col>
      </Row>
    </Container>
  );
}
export default AnalysisKingakuTanka;
